import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type { Feature } from 'geojson';
import type { SearchResultItem } from '../../compound-components/model';
import { SearchResultCardComponent } from '../../compound-components/search-display/search-results/result-card/search-result-card.component';
import { featureToEmbeddingSearchItem } from './pipeline-embeddings-panel.service';

/**
 * Displays a scrollable list of pipeline embedding features using SearchResultCardComponent.
 * Accepts raw GeoJSON features (already pre-enriched with score/scoreColor/centroid/geometryWkt).
 */
@Component({
  selector: 'lib-pipeline-embeddings-feature-list',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SearchResultCardComponent],
  template: `
    <div class="overflow-auto h-100 p-2 d-flex flex-column gap-2">
      @if (searchItems().length === 0) {
        <div class="d-flex align-items-center justify-content-center h-100 text-body-secondary">
          No embedding results available.
        </div>
      }
      @for (item of searchItems(); track item.key; let i = $index) {
        <app-search-result-card
          [item]="item"
          [index]="i"
          [showFeedback]="false"
          (fitToItem)="onNavigateTo(item)"
          (viewDetails)="onDetail(item)" />
      }
    </div>
  `,
})
export class PipelineEmbeddingsFeatureListComponent {
  readonly features = input.required<Feature[]>();
  readonly navigateTo = output<SearchResultItem>();
  readonly detail = output<SearchResultItem>();

  protected readonly searchItems = computed<SearchResultItem[]>(() =>
    this.features().map(featureToEmbeddingSearchItem),
  );

  protected onNavigateTo(item: SearchResultItem): void {
    this.navigateTo.emit(item);
  }

  protected onDetail(item: SearchResultItem): void {
    this.detail.emit(item);
  }
}
